import { COMMA, ENTER, SEMICOLON } from '@angular/cdk/keycodes';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { FlexModule, LayoutGapParent, LayoutGapStyleBuilder, StyleDefinition } from '@angular/flex-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_CHIPS_DEFAULT_OPTIONS, MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LuxonDateAdapter, LuxonDateModule } from '@angular/material-luxon-adapter';

export const DateFormat = {
	parse: {
		dateInput: 'yyyy-LL-dd'
	},
	display: {
		dateInput: 'yyyy-LL-dd',
		monthYearLabel: 'LLL yyyy',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'LLLL yyyy'
	}
};

@Injectable()
export class CustomLayoutGapStyleBuilder extends LayoutGapStyleBuilder {
	buildStyles(gapValue: string, parent: LayoutGapParent): StyleDefinition {
		return super.buildStyles(gapValue || '0 px', parent);
	}

	sideEffect(gapValue, _styles, parent) {
		return super.sideEffect(gapValue || '0 px', _styles, parent);
	}

}

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
		MatMenuModule,
		MatProgressBarModule,
		MatSnackBarModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		MatCheckboxModule,
		MatChipsModule,
		MatButtonToggleModule,
		MatTableModule,
		ScrollingModule,
		MatCardModule,
		MatRadioModule,
		MatAutocompleteModule,
    LuxonDateModule,
		MatDatepickerModule,
		FlexModule,
		MatSlideToggleModule,
		MatPaginatorModule,
		MatRippleModule,
		CdkTableModule,
		PortalModule,
		MatExpansionModule,
		MatSortModule,
		MatSidenavModule,
		MatListModule
	],
	exports: [
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
		MatMenuModule,
		MatProgressBarModule,
		MatSnackBarModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		MatCheckboxModule,
		MatChipsModule,
		MatButtonToggleModule,
		MatTableModule,
		ScrollingModule,
		MatCardModule,
		MatRadioModule,
		MatAutocompleteModule,
    LuxonDateModule,
		MatDatepickerModule,
		FlexModule,
		MatSlideToggleModule,
		MatPaginatorModule,
		MatRippleModule,
		CdkTableModule,
		PortalModule,
		MatExpansionModule,
		MatSortModule,
		MatSidenavModule,
		MatListModule
	],
	providers: [
		{
			provide: MAT_CHIPS_DEFAULT_OPTIONS,
			useValue: {
				separatorKeyCodes: [ENTER, COMMA, SEMICOLON]
			}
		},
		{provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}},
		{provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE]},
		{provide: MAT_DATE_FORMATS, useValue: DateFormat},
		{provide: LayoutGapStyleBuilder, useClass: CustomLayoutGapStyleBuilder}
	]
})
export class MaterialModule {
}
